/**
 * Get cookies
 * @param cname Cookie's name
 * @returns {string} Cookie
 */
const getCookie = cname => {
    let name = cname + "=",
        decodedCookie = decodeURIComponent(document.cookie),
        ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

/**
 * Set a cookie
 * @param cname Cookie's name
 * @param cvalue Cookie's value
 * @param exdays Days to expire
 */
const setCookie = (cname, cvalue, exdays) => {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

$(document).ready(function () {
    const $indexPopup = $('#index_popup');
    if ($indexPopup.length > 0 && !getCookie('ioS')) {
        setTimeout(function () {
            $indexPopup.addClass('active');

            setCookie('ioS', true, 3)
        }, 2000);
    }

    $('.modal-backdrop, .popup-close').on('click', () => {
      $indexPopup.removeClass('active');
    })
});
